import appEnv from 'app/config/appEnv';

import apiConfig from '../api';

interface ScimConfig {
  tenantUrl: string;
  tokenEndpointUrl: string;
}

const scimConfig: ScimConfig = {
  tenantUrl: `${apiConfig.baseURL}/company-manager/scim/v2`,
  tokenEndpointUrl: appEnv.VITE_OAUTH_TOKEN_ENDPOINT_URL,
};

export default scimConfig;
